const WEBVIEW_PATTERNS: Array<[string, RegExp]> = [
  ['instagram', /Instagram/i],
  ['facebook', /FBAN|FBAV|FB_IAB/i],
  ['tiktok', /TikTok|musical_ly|Bytedance/i],
  ['slack', /Slack/i],
  ['snapchat', /Snapchat/i],
  ['pinterest', /Pinterest/i],
  ['line', /\bLine\//i],
  ['wechat', /MicroMessenger/i],
  ['google-app', /\bGSA\//i],
  ['android-webview', /; wv\)/],
];

interface UserActivation {
  isActive: boolean;
  hasBeenActive: boolean;
}

function detectWebview(userAgent: string): string | null {
  for (const [name, pattern] of WEBVIEW_PATTERNS) {
    if (pattern.test(userAgent)) return name;
  }
  if (
    /iPhone|iPad/.test(userAgent) &&
    /Mobile\//.test(userAgent) &&
    !/Safari\//.test(userAgent)
  ) {
    return 'ios-webview';
  }
  return null;
}

const OPENED_THEN_CLOSED_CHECK_MS = 250;

export function watchOpenedWindow(opened: Window, onClosed: () => void): void {
  setTimeout(() => {
    if (opened.closed) {
      onClosed();
    }
  }, OPENED_THEN_CLOSED_CHECK_MS);
}

const REDIRECT_FAILED_CHECK_MS = 4000;

export function watchRedirectDeparture(onFailed: () => void): void {
  const timeoutId = setTimeout(() => {
    if (document.visibilityState === 'visible') {
      onFailed();
    }
  }, REDIRECT_FAILED_CHECK_MS);
  window.addEventListener('pagehide', () => clearTimeout(timeoutId), {
    once: true,
  });
}

export function getBlockedOpenDiagnostics(): Record<string, unknown> {
  const userAgent = navigator.userAgent;
  const activation = (
    navigator as Navigator & { userActivation?: UserActivation }
  ).userActivation;
  const webview = detectWebview(userAgent);
  const framed = window.self !== window.top;

  const blockReason = webview
    ? `webview:${webview}`
    : activation?.isActive === false
      ? 'no_user_activation'
      : framed
        ? 'framed'
        : 'unknown_blocker';

  return {
    blockReason,
    webview,
    framed,
    userActivationActive: activation?.isActive ?? null,
    userActivationHasBeenActive: activation?.hasBeenActive ?? null,
    visibilityState: document.visibilityState,
    hasFocus: document.hasFocus(),
    userAgent,
  };
}
